import { Locale } from 'src/environments/language.config';

export const LANGUAGE_MAP = {
  de: 'Deutsch',
  en: 'English',
};

export type LanguageKey = keyof typeof LANGUAGE_MAP;

export function getLocalizedUrl(lang: string, path: string): string {
  const [pathAndQuery, hash = ''] = path.split('#');
  const [pathname, query = ''] = pathAndQuery.split('?');

  const pathSegments = pathname.split('/').filter(Boolean);
  const cleanPath = '/' + pathSegments.join('/');
  const barePath = cleanPath.replace(/^\/en(\/|$)/, '/');
  const localizedPath = lang === Locale.EN ? `/en${barePath}` : barePath;
  const querySuffix = query ? `?${query}` : '';
  const hashSuffix = hash ? `#${hash}` : '';

  return `${localizedPath}${querySuffix}${hashSuffix}`;
}
